export interface ICreateFundedAccountTypeFormData {
  title: string;
  leverage: number;
  initialBalance: number;
  minTradingDays: number;
  maxInactivityDays: number;
  maxDailyDrawdownFactor: number;
  maxTotalDrawdownFactor: number;
  traderProfitShareFactor?: number;
  accountGroup: string;
  accountCurrency: string;
  behavior: FundedAccountBehavior;
  profitTargetFactor?: number;
  isDemo?: boolean;
}

export interface IUpdateFundedAccountTypeFormData {
  title?: string;
  leverage?: number;
  initialBalance?: number;
  minTradingDays?: number;
  maxInactivityDays?: number;
  maxDailyDrawdownFactor?: number;
  maxTotalDrawdownFactor?: number;
  traderProfitShareFactor: number;
  accountGroup?: string;
  accountCurrency?: string;
  profitTargetFactor?: number;
  behavior: FundedAccountBehavior;
  isDemo?: boolean;
}

export interface IFundedAccountType {
  id: number;
  title: string;
  leverage: number;
  initialBalance: number;
  minTradingDays: number;
  maxInactivityDays: number;
  maxDailyDrawdownFactor: number;
  traderProfitShareFactor?: number;
  maxTotalDrawdownFactor: number;
  accountGroup: string;
  accountCurrency: string;
  behavior: FundedAccountBehavior;
  profitTargetFactor?: number;
  isDemo: boolean;
}

export enum FundedAccountBehavior {
  REGULAR = 'REGULAR',
  BINARY = 'BINARY',
}

export interface IGetFundedAccountTypeResponse {
  fundedAccountType: IFundedAccountType;
  canModify: boolean;
  canDelete: boolean;
}
